<template>
  <el-form
    :model="optionData"
    :rules="optionRules"
    label-width="100px"
  >
    <el-form-item label="饼图标题" prop="title">
      <el-input style="width: 320px;max-width: 500px;" placeholder="请输入饼图标题显示标题..." :minlength="3" :maxlength="20" v-model="optionData.title"></el-input>
    </el-form-item>
    <el-form-item label="标题颜色" prop="titleColor">
      <el-color-picker popper-class="my-color-picker" v-model="optionData.titleColor" show-alpha></el-color-picker>
      <div>
        <el-link type="primary">tip：默认标题颜色灰黑色。</el-link>
      </div>
    </el-form-item>
    <el-form-item label="标题位置" prop="titlePosition">
        <el-radio-group v-model="optionData.titlePosition">
            <el-radio label="auto">自动</el-radio>
            <el-radio label="left">左边</el-radio>
            <el-radio label="center">中间</el-radio>
            <el-radio label="right">右边</el-radio>
        </el-radio-group>
    </el-form-item>
    <el-form-item label="饼图半径比" prop="radius">
      <el-slider style="max-width: 500px;" v-model="optionData.radius" show-input input-size="mini"></el-slider>
      <div>
        <el-link type="primary">tip：圆半径长度占整个图的比例。</el-link>
      </div>
    </el-form-item>
    <el-form-item label="开启扇形间隙" prop="border">
      <el-switch v-model="optionData.border"></el-switch>
    </el-form-item>
    <el-form-item v-show="optionData.border" label="颜色" prop="borderStyle.color">
      <el-color-picker popper-class="my-color-picker" v-model="optionData.borderStyle.color" show-alpha></el-color-picker>
    </el-form-item>
    <el-form-item v-show="optionData.border" label="宽度" prop="borderStyle.width">
      <el-slider style="max-width: 400px;" v-model="optionData.borderStyle.width" show-input input-size="mini" :min="0" :max="5"></el-slider>
    </el-form-item>
    <el-form-item v-show="optionData.border" label="圆角" prop="borderStyle.radius">
      <el-slider style="max-width: 400px;" v-model="optionData.borderStyle.radius" show-input input-size="mini" :min="0" :max="20"></el-slider>
    </el-form-item>
    <el-form-item label="扇形边缘阴影" prop="shadow">
      <el-switch v-model="optionData.shadow"></el-switch>
    </el-form-item>
    <el-form-item label="开启环形饼图" prop="ring">
      <el-switch v-model="optionData.ring"></el-switch>
    </el-form-item>
    <el-form-item v-show="optionData.ring" label="半径比设置" prop="ringRadius">
        <div>
            内径比(内圆半径比例)：
            <el-slider style="max-width: 500px;" v-model="optionData.ringRadius[0]" show-input input-size="mini"></el-slider>
        </div>
        <div>
            外径比(外圆半径比例)：
            <el-slider style="max-width: 500px;" v-model="optionData.ringRadius[1]" show-input input-size="mini"></el-slider>
        </div>
        <div>
            <el-link type="primary">tip：结合环形饼图生效。</el-link>
        </div>
    </el-form-item>
    <el-form-item label="开启玫瑰图" prop="rose">
      <el-switch v-model="optionData.rose"></el-switch>
    </el-form-item>
    <el-form-item v-show="optionData.rose" label="半径设置" prop="roseRadius">
        <div>
            内径(内圆半径)：
            <el-slider style="max-width: 500px;" v-model="optionData.roseRadius[0]" show-input input-size="mini" :min="0" :max="250"></el-slider>
        </div>
        <div>
            外径(外圆半径)：
            <el-slider style="max-width: 500px;" v-model="optionData.roseRadius[1]" show-input input-size="mini" :min="50" :max="300"></el-slider>
        </div>
        <div>
            <el-link type="primary">tip：结合玫瑰图生效。</el-link>
        </div>
    </el-form-item>
    <el-form-item label="饼图后背景" prop="background">
      <div>
        <el-radio-group @change="radioChange" v-model="bigback">
          <el-radio label="color">纯色</el-radio>
          <el-radio label="img">图片</el-radio>
        </el-radio-group>
      </div>
      <template v-if="bigback === 'color'">
        <el-color-picker popper-class="my-color-picker" v-model="optionData.background" show-alpha></el-color-picker>
        <div>
          <el-link type="primary">tip：默认背景色透明。</el-link>
        </div>
      </template>
      <template v-else>
        <el-input style="width: 320px;max-width: 500px;" placeholder="请输入网络图片地址..." v-model="optionData.background"></el-input>
      </template>
    </el-form-item>
    <el-form-item label="图片填充饼图区域" prop="imgFill">
      <el-switch @change="switchChange" v-model="piefill"></el-switch>
      <el-input v-if="piefill" style="width: 320px;max-width: 400px;padding-left: 10px;" placeholder="请输入网络图片地址..." v-model="optionData.imgFill"></el-input>
    </el-form-item>
    <el-form-item label="显示图例" prop="legend">
      <el-switch v-model="optionData.legend"></el-switch>
    </el-form-item>
    <el-form-item v-show="optionData.legend" label="图例位置" prop="legendPosition">
        <el-radio-group v-model="optionData.legendPosition">
            <el-radio label="auto">自动</el-radio>
            <el-radio label="left">左边</el-radio>
            <el-radio label="center">中间</el-radio>
            <el-radio label="right">右边</el-radio>
        </el-radio-group>
        <div>
            <el-link type="primary">tip：只在显示图例的情况下生效。</el-link>
        </div>
    </el-form-item>
    <el-form-item v-show="optionData.legend" label="图例方向" prop="legendDirection">
        <el-radio-group v-model="optionData.legendDirection">
          <el-radio label="horizontal">水平排列</el-radio>
          <el-radio label="vertical">垂直排列</el-radio>
        </el-radio-group>
        <div>
          <el-link type="primary">tip：只在显示图例的情况下生效。</el-link>
        </div>
    </el-form-item>
    <el-form-item label="提供图片下载" prop="saveAsImage">
      <el-switch v-model="optionData.saveAsImage"></el-switch>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      optionData: {
        title: "", // 饼图标题
        titleColor: "#333", // 标题颜色
        titlePosition: "auto", // 标题位置
        radius: 50, // 饼图半径百分比
        border: false, // 边框间隙
        borderStyle: {
          width: 2,
          color: "#333",
          radius: 8
        }, // 边框宽度、颜色
        rose: false, // 开启玫瑰图
        roseRadius: [50,250], // 半径内外径长
        shadow: false, // 开启扇形hover阴影
        ring: false, // 开启环形饼图
        ringRadius: [40,70], // 环形内外径
        background: "#00000000", // 默认背景色
        imgFill: false, // 饼图图片地址
        legend: false, // 显示图例
        legendPosition: "auto", // 图例位置
        legendDirection: "horizontal", // 图例方向
        saveAsImage: false
      },
      optionRules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          { min: 3, max: 20, message: "长度在 3 到 20 个字符", trigger: "blur" }
        ],
        background: [
          { required: true, message: "请输入网络图片地址", trigger: "blur" }
        ]
      },
      bigback: 'color',
      piefill: false
    };
  },
  methods: {
    radioChange(val) {
      val === "color" && (this.optionData.background = "#00000000");
      val === "img" && (this.optionData.background = "");
    },
    switchChange(val) {
      val && (this.optionData.imgFill = "");
      !val && (this.optionData.imgFill = val);
    },
    getOption() {
      if(!this.optionData.title.trim()) {
        return "请输入图形标题！"
      }
      if(!this.optionData.background.trim()) {
        return "请检查背景设置！"
      }
      if(!(/^rgba?\(.*\)$/.test(this.optionData.background) || /^#[0-9a-fA-F]{8}$/.test(this.optionData.background) || /^(https?:\/\/)/.test(this.optionData.background))) {
        return "请检查背景设置格式！"
      }
      if(this.piefill) {
        if(!this.optionData.imgFill.trim()) {
          return "请检查饼图填充设置！"
        }
        if(!/^(https?:\/\/)/.test(this.optionData.imgFill)) {
          return "请输入正确的网络图片地址！"
        }
      }
      return JSON.parse(JSON.stringify(this.optionData))
    }
  }
};
</script>

<style>
.my-color-picker {
    z-index: 10001!important;
}
</style>